@if (role) {
  <h3 i18n>Copy of {{ role.title }}</h3>
}
<mat-card appearance="outlined">
  <app-form-default [formData$]="formData$" (submitted)="onSubmit()"></app-form-default>
</mat-card>
